
import { Exhibit } from '../types';

export const outdoorSculptureExhibits: Exhibit[] = [
  {
    id: 9,
    numberCode: "301",
    titleEn: "Modern Sculpture Garden",
    titleHe: "גן הפסלים המודרני",
    descriptionEn: "An outdoor exhibition showcasing contemporary sculptures from international artists.",
    descriptionHe: "תערוכת חוץ המציגה פסלים עכשוויים מאמנים בינלאומיים.",
    image: "https://images.unsplash.com/photo-1638786813466-78e30a8797f2",
    hasAudio: true,
    hasVideo: false,
    location: {
      floor: 0,
      room: "Outdoor Garden",
      latitude: 32.0853,
      longitude: 34.7818
    }
  },
  {
    id: 10,
    numberCode: "302",
    titleEn: "Water and Stone",
    titleHe: "מים ואבן",
    descriptionEn: "A mesmerizing water feature with contemporary stone sculptures.",
    descriptionHe: "מתקן מים מהפנט עם פסלי אבן עכשוויים.",
    image: "https://images.unsplash.com/photo-1433086966358-54859d0ed716",
    hasAudio: true,
    hasVideo: true,
    location: {
      floor: 0,
      room: "Fountain Plaza",
      latitude: 32.0860,
      longitude: 34.7825
    }
  },
  {
    id: 11,
    numberCode: "303",
    titleEn: "Metal Perspectives",
    titleHe: "פרספקטיבות מתכת",
    descriptionEn: "A series of metal sculptures exploring perspective and space.",
    descriptionHe: "סדרת פסלי מתכת החוקרים פרספקטיבה ומרחב.",
    image: "https://images.unsplash.com/photo-1616514169928-a1e40c6f791c",
    hasAudio: false,
    hasVideo: true,
    location: {
      floor: 0,
      room: "Sculpture Court",
      latitude: 32.0847,
      longitude: 34.7830
    }
  },
  {
    id: 12,
    numberCode: "304",
    titleEn: "Urban Installation",
    titleHe: "התקנה אורבנית",
    descriptionEn: "A thought-provoking piece on urban development and human interaction.",
    descriptionHe: "יצירה מעוררת מחשבה על התפתחות עירונית ואינטראקציה אנושית.",
    image: "https://images.unsplash.com/photo-1563241527-3004b7be0ffd",
    hasAudio: true,
    hasVideo: false,
    location: {
      floor: 0,
      room: "Street View",
      latitude: 32.0865,
      longitude: 34.7810
    }
  }
];
